export const string = 1;
export const number = 2;
export const boolean = 4;
export const any = 8;
export const date = 16;
export const nullable = 32;
export const object = 64;
export const dateDay = 128;
export const dateMinute = 256;
